import graphql from "babel-plugin-relay/macro";

const query = graphql`
  query SessionQuery($path: String) {
    currentTenant {
      name
      subdomain
      showApplicability
      isIsland
      settings {
        labels {
          approvedDateLabel
          authorLabel
          authorLabelPlural
          categoryLabel
          categoryLabelPlural
          documentLabel
          documentLabelPlural
          effectiveDateLabel
          expirationDateLabel
          guestLabel
          originationDateLabel
          referencesLabel
          referencesLabelPlural
          revisionDateLabel
        }
        enableAllBlocs
        enableEditWithWord
        standardsAndRegulationsEnabled
        onesourceIntegrationEnabled
        vergeIntegrationEnabled
        enableEnterprise
      }
      samlSettings {
        isActive
        location
        samlRequest(path: $path)
      }
      documentSettings {
        showCommittee
        approvedDateShow
        authorShow
        departmentShow
        effectiveDateShow
        expirationDateShow
        originationDateShow
        referencesShow
        revisionDateShow
        footerHtml
        headerHtml
        editorStyles
        viewStyles
      }
      hasScheduledEffectiveDateEnabled
      acknowledgmentsEnabled
      customerSettings {
        enableEnterprisePolicySharing
      }
    }
    viewer {
      pk
      algoliaDocumentsIndexName
      algoliaAccessKey
      isGuest
      isStaff
      canReverseProxyLogin
      userAuth {
        isSiteAdmin
        canCreateDocuments
        canManageCertifications
        canViewReviewSetList
        canAcceptTemplates
      }
      forceChooseHomeTenant
      userDisplay(userDisplayType: SHORT_FORWARD, showStaff: true)
      hasOnesourceToken
    }
    settings {
      recaptchaPublicKey
      showChangesWarningBanner
    }
  }
`;

export default query;
